import React from 'react';
import './PhoneMockup.css';

function PhoneMockup() {
  return (
    <div className="phone-mockup">
      <div className="phone-screen">
        <div className="mock-header">
          <span className="mock-greeting">Good Morning!</span>
          <span className="mock-month">March 2026</span>
        </div>

        <div className="mock-cards">
          <div className="mock-card mock-card-income">
            <span className="mock-card-label">Income</span>
            <span className="mock-card-value">&#8377;75,000</span>
          </div>
          <div className="mock-card mock-card-expense">
            <span className="mock-card-label">Expenses</span>
            <span className="mock-card-value">&#8377;42,300</span>
          </div>
        </div>

        <div className="mock-chart">
          <div className="mock-donut">
            <svg viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#E5E7EB" strokeWidth="12" />
              <circle cx="50" cy="50" r="40" fill="none" stroke="#1A6B4A" strokeWidth="12"
                strokeDasharray="100 151" strokeDashoffset="0" transform="rotate(-90 50 50)" />
              <circle cx="50" cy="50" r="40" fill="none" stroke="#2ECC71" strokeWidth="12"
                strokeDasharray="60 191" strokeDashoffset="-100" transform="rotate(-90 50 50)" />
              <circle cx="50" cy="50" r="40" fill="none" stroke="#F39C12" strokeWidth="12"
                strokeDasharray="40 211" strokeDashoffset="-160" transform="rotate(-90 50 50)" />
              <circle cx="50" cy="50" r="40" fill="none" stroke="#E74C3C" strokeWidth="12"
                strokeDasharray="30 221" strokeDashoffset="-200" transform="rotate(-90 50 50)" />
            </svg>
            <span className="mock-donut-center">
              &#8377;32.7K<br /><small>saved</small>
            </span>
          </div>
        </div>

        <div className="mock-transactions">
          <div className="mock-txn">
            <span className="mock-txn-icon" style={{ background: '#FEF3C7' }}>&#127860;</span>
            <span className="mock-txn-name">Lunch</span>
            <span className="mock-txn-amount expense">-&#8377;450</span>
          </div>
          <div className="mock-txn">
            <span className="mock-txn-icon" style={{ background: '#DBEAFE' }}>&#128663;</span>
            <span className="mock-txn-name">Uber Ride</span>
            <span className="mock-txn-amount expense">-&#8377;280</span>
          </div>
          <div className="mock-txn">
            <span className="mock-txn-icon" style={{ background: '#D1FAE5' }}>&#128176;</span>
            <span className="mock-txn-name">Salary</span>
            <span className="mock-txn-amount income">+&#8377;75,000</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PhoneMockup;
